import React from 'react';
import {Tooltip} from '@mantine/core';

import {Container, Loader, Loading} from './styles';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export interface CircleButtonProps extends ButtonProps {
  onClick?: (e: any) => any | Promise<any>;
  loading?: boolean;
  icon?: React.ReactNode;
  tooltip?: string;
  visible?: boolean;
  color?: string;
}

const CircleButton: React.FC<CircleButtonProps> = ({
  loading,
  icon,
  tooltip,
  visible = true,
  onClick,
  ...props
}) => {
  const getContent = () => (
    <Container
      disabled={loading}
      type="submit"
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) onClick(e);
      }}
      {...props}>
      {!loading && icon}
      {loading && (
        <Loader>
          <Loading />
        </Loader>
      )}
    </Container>
  );

  if (!visible) return null;

  return tooltip ? (
    <Tooltip position="top" label={tooltip}>
      {getContent()}
    </Tooltip>
  ) : (
    getContent()
  );
};

export default CircleButton;
